import React, { useRef } from "react";
import { FileUp } from 'lucide-react';
import { cn } from "@/utils/cn";

export interface FileUploadProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helperText?: React.ReactNode;
  onFileSelect?: (files: FileList | null) => void;
  icon?: React.ReactNode;
}

export const FileUpload: React.FC<FileUploadProps> = ({
  label = "Upload File",
  helperText,
  accept,
  multiple = false,
  onFileSelect,
  icon,
  className,
  ...props
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleClick = () => inputRef.current?.click();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    onFileSelect?.(files);
  };

  return (
    <div className="w-full">
      <div
        onClick={handleClick}
        className={cn(
          "border-2 border-dashed border-[#7b2a40] rounded-lg px-6 py-4",
          "flex items-center justify-center gap-2 text-[#7b2a40] text-sm font-medium cursor-pointer select-none",
          "bg-[#7b2a40]/5 hover:bg-[#7b2a40]/10 transition-colors duration-150",
          className
        )}
      >
        {icon ?? <FileUp className="w-5 h-5" />}
        <span>{label}</span>
        <input
          ref={inputRef}
          type="file"
          accept={accept}
          multiple={multiple}
          onChange={handleChange}
          className="hidden"
          {...props}
        />
      </div>

      {helperText && (
        <div className="text-xs text-gray-500 mt-2 leading-snug">{helperText}</div>
      )}
    </div>
  );
};
